import React from "react";
import { useNavigate } from "react-router";
import Button from "../../../components/button";
import DocumentPage from "../../../components/document-page";
import styles from '../styles.module.css';
import { HelpLink } from "../../../common/help";

function UserAgreementPage() {
  const navigation = useNavigate();

  const handleClickPrevPage = () => {
    navigation('/account');
  }

  return (
       <DocumentPage variant="scrollable" className="user-agreement-container">
        <h1>Пользовательское соглашение</h1>
        <hr/>        
        <div className="important-note">
            <p>
                Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения между администрацией сервиса «Openway» (далее — Сервис, Администрация) и физическим лицом (далее — Пользователь), использующим услуги Сервиса.<br/><br/>
                Использование Сервиса означает полное и безоговорочное согласие Пользователя с условиями настоящего Соглашения.
            </p>
        </div>

        <div className="section">
            <h2>1. Общие положения</h2>
            <p><strong>1.1.</strong> Сервис «Openway» предоставляет Пользователю доступ к услугам виртуальной частной сети на условиях, изложенных в настоящем Соглашении.</p>
            <p><strong>1.2.</strong> Настоящее Соглашение является публичной офертой. Регистрация, оплата или фактическое использование Сервиса означает принятие условий Соглашения.</p>
            <p><strong>1.3.</strong> Если Пользователь не согласен с условиями Соглашения, он обязан прекратить использование Сервиса.</p>
        </div>

        <div className="section">
            <h2>2. Описание услуг</h2>
            <p><strong>2.1.</strong> Сервис предоставляет доступ к соединению с целью обеспечения защищённого и зашифрованного интернет-соединения.</p>
            <p><strong>2.2.</strong> Конкретные параметры услуг (тарифы, срок действия, количество устройств и иные условия) определяются выбранным тарифом.</p>
            <p><strong>2.3.</strong> Сервис предоставляет услуги без гарантии бесперебойной и безошибочной работы.</p>
        </div>

        <div className="section">
            <h2>3. Регистрация и доступ к сервису</h2>
            <p><strong>3.1.</strong> Для использования Сервиса Пользователь проходит регистрацию через Telegram-бота.</p>
            <p><strong>3.2.</strong> Пользователь несёт ответственность за сохранность данных доступа и обязуется не передавать их третьим лицам.</p>
            <p><strong>3.3.</strong> Сервис вправе отказать в предоставлении услуг или приостановить доступ в случае нарушения условий Соглашения.</p>
        </div>

        <div className="section">
            <h2>4. Права и обязанности пользователя</h2>
            
            <h3>4.1. Пользователь имеет право:</h3>
            <ul>
                <li>использовать Сервис в рамках настоящего Соглашения;</li>
                <li>получать оплаченные услуги в течение срока подписки;</li>
                <li>обратиться в службу поддержки по вопросам работы Сервиса.</li>
            </ul>

            <h3>4.2. Пользователь обязуется:</h3>
            <ul>
                <li>соблюдать законодательство страны своего пребывания;</li>
                <li>не использовать Сервис для противоправных действий;</li>
                <li>не пытаться вмешиваться в работу Сервиса;</li>
                <li>не использовать Сервис для распространения вредоносного ПО, спама или атак.</li>
            </ul>
        </div>

        <div className="section">
            <h2>5. Запрещённые действия</h2>
            <p>Пользователю запрещается:</p>
            <ul>
                <li>использовать Сервис для действий, нарушающих действующее законодательство;</li>
                <li>использовать Сервис для взлома, атак, мошенничества;</li>
                <li>передавать доступ к Сервису третьим лицам, если это запрещено тарифом;</li>
                <li>пытаться получить несанкционированный доступ к серверам или системам Сервиса.</li>
            </ul>
            <p>Администрация не несёт ответственности за действия Пользователя.</p>
        </div>

        <div className="section">
            <h2>6. Платежи и подписка</h2>
            <p><strong>6.1.</strong> Услуги Сервиса предоставляются на платной основе в соответствии с выбранным тарифом.</p>
            <p><strong>6.2.</strong> Оплата осуществляется через сторонние платёжные системы. Сервис не обрабатывает и не хранит платёжные данные Пользователя.</p>
            <p><strong>6.3.</strong> Подписка активируется после подтверждения оплаты.</p>
            <p><strong>6.4.</strong> Возврат средств осуществляется в случаях и порядке, предусмотренных действующим законодательством, либо по усмотрению Администрации.</p>
        </div>

        <div className="section">
            <h2>7. Ограничение ответственности</h2>
            
            <h3>7.1. Администрация не несёт ответственности за:</h3>
            <ul>
                <li>действия Пользователя при использовании Сервиса;</li>
                <li>блокировки, ограничения или санкции, применённые к Пользователю третьими лицами;</li>
                <li>сбои в работе интернета, оборудования или сторонних сервисов.</li>
            </ul>

            <h3>7.2. Сервис не гарантирует:</h3>
            <ul>
                <li>постоянную доступность;</li>
                <li>отсутствие технических ошибок;</li>
                <li>соответствие ожиданиям Пользователя.</li>
            </ul>
        </div>

        <div className="section">
            <h2>8. Приостановка и прекращение предоставления услуг</h2>
            <p><strong>8.1.</strong> Администрация вправе приостановить или прекратить доступ Пользователя к Сервису без предварительного уведомления в случае нарушения условий Соглашения.</p>
            <p><strong>8.2.</strong> Администрация вправе прекратить предоставление услуг в любое время по техническим или организационным причинам.</p>
        </div>

        <div className="section">
            <h2>9. Политика конфиденциальности</h2>
            <p><strong>9.1.</strong> Обработка персональных данных Пользователя осуществляется в соответствии с Политикой конфиденциальности Сервиса «Openway».</p>
            <p><strong>9.2.</strong> Используя Сервис, Пользователь подтверждает согласие с Политикой конфиденциальности.</p>
        </div>

        <div className="section">
            <h2>10. Изменение условий соглашения</h2>
            <p><strong>10.1.</strong> Администрация вправе в любое время изменять настоящее Соглашение.</p>
            <p><strong>10.2.</strong> Новая редакция вступает в силу с момента публикации. Продолжение использования Сервиса означает согласие Пользователя с изменениями.</p>
        </div>

        <div className="section">
            <h2>11. Разрешение споров</h2>
            <p><strong>11.1.</strong> Все споры и разногласия решаются путём переговоров.</p>
            <p><strong>11.2.</strong> При невозможности урегулирования спора он подлежит рассмотрению в соответствии с действующим законодательством.</p>
        </div>

        <div className="company-info">
            <h2>12. Контактная информация</h2>
            <p><strong>Telegram:</strong> <a href={HelpLink} target="_blank" rel="noreferrer">{HelpLink}</a></p>
        </div>

        <div className="footer-note">
            <p>© 2026 Openway. Все права защищены.</p>
        </div>
        <Button className={styles.btn} label="Назад" onClick={() => handleClickPrevPage()}></Button>
    </DocumentPage>
  );
}

export default UserAgreementPage;